import React from 'react';
import LiveRegion from '~/components/LiveRegion';
import { getAppContext } from '~/lib/AppContext';

// Layout-level polite screen-reader announcer for the AppContext `announce` bus.
// Visually hidden: a pure SR affordance, unlike the visible toast NotificationCenter.
export default class Announcer extends React.Component {
    render() {
        return <LiveRegion source={getAppContext().announce} />;
    }
}
